<template>
  <div>
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-dialog v-model="editDialog">
        <v-card>
          <v-card-text>
            <FormView
              v-if="editDialog"
              :type="type"
              :persistence="persistence"
              :_entity="edit_entity"
              :id="edit_entity ? edit_entity.id : undefined"
              mode="edit"
              :scope="scope"
              :popup="forms === 'popup'"
              @close="onFormClose"
            ></FormView>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-data-table
        disable-sort
        dense
        :headers="headers"
        :items="entities"
        :options.sync="tableOptions"
        :loading="loading"
        :server-items-length="totalItems"
        :footer-props="{ itemsPerPageOptions: amounts }"
        :hide-default-footer="disablePagination"
        class="mb-4"
      >
        <template v-slot:top v-if="hasSearch || listActions.length">
          <v-toolbar flat>
            <v-text-field
              v-if="hasSearch"
              v-model="appliedFilters.search_query"
              label="Поиск"
              class="mx-4"
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-card>
              <v-layout>
                <template v-for="action in listActions">
                  <v-dialog
                    :key="action.name"
                    v-if="action.name == 'create' && forms == 'popup'"
                    v-model="dialog"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn dark right :color="action.color" v-on="on">{{
                        action.title
                      }}</v-btn>
                    </template>
                    <v-card>
                      <v-card-text>
                        <FormView
                          v-if="dialog"
                          :type="type"
                          :persistence="persistence"
                          :scope="scope"
                          :popup="forms === 'popup'"
                          @close="onFormClose"
                        ></FormView>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                  <v-btn
                    :key="action.name"
                    v-else
                    dark
                    right
                    :color="action.color"
                    @click="getListAction(action)"
                    >{{ action.title }}</v-btn
                  >
                </template>
              </v-layout>
            </v-card>
          </v-toolbar>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="column in columns" :key="column.name">
              <component
                :is="getColumnWidget(column)"
                :entity_type="type"
                :entity="item"
                :column="column"
                v-model="item[column.name]"
              ></component>
            </td>
            <td>
              <v-layout>
                <v-spacer></v-spacer>
                <v-btn
                  class="mr-2 mt-1 mb-1"
                  fab
                  small
                  v-for="action in itemActions"
                  :key="action.name"
                  @click="getItemAction(action, item)"
                >
                  <v-icon :color="action.color">{{ action.icon }}</v-icon>
                  {{ action.title }}
                </v-btn>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import entities from "./../api/entities";
import StringColumn from "./columns/StringColumn";
import DateColumn from "./columns/DateColumn";
import DateTimeColumn from "./columns/DateTimeColumn";
import DateTimePickerColumn from "./columns/DateTimePickerColumn";
import BooleanColumn from "./columns/BooleanColumn";
import ActionsColumn from "./columns/ActionsColumn";
import LinkColumn from "./columns/LinkColumn";
import ImageColumn from "./columns/ImageColumn";
import SwitchColumn from "./columns/SwitchColumn";

import createAction from "./../classes/actions/create";
import deleteAction from "./../classes/actions/delete";
import editAction from "./../classes/actions/edit";
import { logState } from "../classes/logging";

const widgets = {
  actions: "ActionsColumn",
  boolean: "BooleanColumn",
  date: "DateColumn",
  datetime: "DateTimeColumn",
  datetime_picker: "DateTimePickerColumn",
  link: "LinkColumn",
  image: "ImageColumn",
  string: "StringColumn",
  switch: "SwitchColumn"
};

export default {
  name: "AdvancedListView",
  components: {
    // FormView,
    StringColumn,
    DateColumn,
    DateTimeColumn,
    DateTimePickerColumn,
    BooleanColumn,
    ActionsColumn,
    LinkColumn,
    ImageColumn,
    SwitchColumn
  },
  props: [
    "persistence",
    "type",
    "scope",
    "options",
    "filters",
    "state",
    "forms"
  ],
  // persistence: 'permanent' or 'dependent
  // type: entity type (string)
  // options: {
  //   amounts: [5, 10, 20],
  //   default_amount: 10
  // }
  // state: {
  //   page:
  //   amount:
  // }
  // scope: {
  //   parent_id: 11
  // }
  // filters: {
  //   search_query: true
  // }
  // forms: 'popup' or 'link'
  data() {
    return {
      // TODO: refactor storing and/or passing options
      receivedTitle: "",
      receivedHasSearch: false,
      columns: [],
      entities: [],

      listActions: [],
      itemActions: [],

      headers: [],

      totalItems: 1,

      tableOptions: {
        page: 1,
        itemsPerPage: 10
      },
      appliedFilters: {
        search_query: ""
      },

      loading: false,
      searchAction: false, // Устаревший action = "search"

      dialog: false,
      editDialog: false,
      edit_entity: false
    };
  },
  computed: {
    amount() {
      return this.tableOptions.itemsPerPage;
    },
    amounts() {
      return this.options ? this.options.amounts : [10, 20, 50];
    },
    offset() {
      return (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage;
    },
    title() {
      if (this.receivedTitle) return this.receivedTitle;
      return this.options && this.options.title ? this.options.title : "";
    },
    hasSearch() {
      if (this.receivedHasSearch) return this.receivedHasSearch;
      return (
        this.receivedHasSearch !== false &&
        this.options &&
        this.options.hasSearch
      );
      // return this.filters ? this.filters.search_query : this.searchAction;
    },
    disablePagination() {
      return this.options && this.options.disablePagination;
    }
  },
  beforeCreate: function() {
    this.$options.components.FormView = require("./FormView").default;
  },
  created() {
    this.tableOptions.itemsPerPage = this.state ? this.state.amount : 10;
    this.tableOptions.page = this.state ? this.state.page : 1;
  },
  mounted() {
    logState(
      "AdvancedListView.mounted",
      { color: "blue" },
      "scope:",
      this.scope
    );
    this.loadEntities();
    if (this.persistence == "dependent") {
      this.$root.$on("add_to_list", this.onAddToList);
      this.$root.$on("change_list_item", this.onChangeListItem);
    }
    this.$root.$on("reload_entities", this.onReloadEntities);
  },
  // TODO: remove event handlers in beforeDestroy?
  destroyed() {
    this.$root.$off("add_to_list", this.onAddToList);
    this.$root.$off("change_list_item", this.onChangeListItem);
    this.$root.$off("reload_entities", this.onReloadEntities);
  },
  methods: {
    onFormClose() {
      this.dialog = false;
      this.editDialog = false;
      if (this.persistence === "permanent") this.loadEntities();
    },
    async onReloadEntities() {
      this.loadEntities();
    },
    async onAddToList(type, entity, form) {
      console.log("AdvancedListView.onAddToList", type, entity, this.entities);
      // TODO: type isn't best solution, what if we have multuple listviews of the same type?
      if (this.type == type) {
        console.log("adding entity to AdvancedListView");
        const result = await entities.list_item(this.token, this.type, entity);
        if (result && !result.success && result.error === "DATA_ERROR") {
          form.errors = result.message;
        } else {
          this.entities.push(result.entity);
          this.totalItems += 1;
          this.dialog = false;
        }
      }
    },
    async onChangeListItem(type, entity, old_entity, form) {
      if (this.type == type) {
        logState(
          "AdvancedListView.onChangeListItem",
          { color: "orange" },
          "new entity:",
          entity,
          "old entity:",
          old_entity
        );
        const result = await entities.list_item(this.token, this.type, entity);
        console.log("RRRR", result);
        console.log("IIIII", this.entities.indexOf(old_entity));
        if (result && !result.success && result.error === "DATA_ERROR") {
          form.errors = result.message;
        } else {
          for (let [key, value] of Object.entries(result.entity)) {
            old_entity[key] = value;
          }
          this.editDialog = false;
        }
      }
    },
    async loadEntities() {
      const result = await entities.list(
        this.token,
        this.type,
        this.amount,
        this.offset,
        this.scope,
        this.appliedFilters
      );

      if (result.actions) {
        console.warn(
          "Old API version, actions was replaced with list_actions and item_actions"
        );
        this.listActions = [];
        this.itemActions = [];
        if (result.actions.indexOf("create") > -1)
          this.listActions.push({
            name: "create",
            title: "Создать",
            color: "blue-grey",
            path: {
              name: "entity_create",
              params: {
                type: this.type // TODO: rename to entity_type
              }
            }
          });
        if (result.actions.indexOf("edit") > -1)
          this.itemActions.push({
            name: "edit",
            icon: "edit",
            color: "cyan",
            path: {
              name: "entity_edit",
              params: {
                type: this.type, // TODO: rename to entity_type
                id: "@id"
              }
            }
          });
        if (result.actions.indexOf("delete") > -1)
          this.itemActions.push({
            name: "delete",
            icon: "delete",
            color: "red",
            click: this.deleteDialog,
            args: [this.type, "@id"]
          });
        this.searchAction = result.actions.indexOf("search") > -1;
      } else {
        this.listActions = result.list_actions || [];
        this.itemActions = result.item_actions || [];
      }

      this.totalItems = result.total_items;
      if (result.title) {
        // console.log("TITLE received", result.title);
        this.receivedTitle = result.title;
      }
      this.entities = result.entities;
      this.columns = result.columns;
      if (result.has_search) this.receivedHasSearch = true;

      this.headers = [];
      for (const column of this.columns) {
        this.headers.push({
          text: column.label,
          value: column.name
        });
      }
      this.headers.push({ text: "", value: "actions" });
    },
    getColumnWidget(column) {
      return (
        (column.widget && column.widget.name && widgets[column.widget.name]) ||
        (column.widget && widgets[column.widget]) ||
        widgets[column.type] ||
        "StringColumn"
      );
    },
    async deleteDialog(type, id) {
      if (confirm(`Удалить запись ${id} навсегда?`)) {
        const response = await entities.delete(this.token, type, id);
        if (response.success) this.loadEntities();
        else this.$root.$emit("notify", "Не удалось удалить запись", "red");
      }
    },
    // старая реализация
    getActionPath(action, entity) {
      let path = {
        name: action.path.name,
        params: {}
      };
      for (let [key, value] of Object.entries(action.path.params)) {
        if (value.startsWith("@")) {
          value = entity[value.substr(1)];
        }
        path.params[key] = value;
      }
      return path;
    },
    // старая реализация
    getActionClick(action, entity) {
      let args = [];
      for (const arg of action.args) {
        if (arg.startsWith("@")) args.push(entity[arg.substr(1)]);
        else args.push(arg);
      }
      console.warn(args);
      return action.click.apply(this, args);
    },
    // TODO: вынести действия в отдельные компоненты
    getListAction({ action }) {
      console.log("AdvancedListView.getListAction", action);
      const actions_list = {
        create: createAction
      };
      console.log("getListAction", action);
      if (typeof action == "string" && actions_list[action]) {
        const action_obj = new actions_list[action]({
          root: this.$root,
          entity_type: this.type
        });
        action_obj.execute();
      } else {
        console.error("No such action", action);
      }
    },
    // TODO: action => name, remove action from backend
    getItemAction({ action, popup }, entity) {
      const actions_list = {
        delete: deleteAction,
        edit: editAction
      };
      if (typeof action == "string" && actions_list[action]) {
        if (action == "edit" && (this.persistence == "dependent" || popup)) {
          this.edit_entity = entity;
          console.log("JJJJJJ", entity);
          this.editDialog = true;
          return;
        }

        if (this.persistence == "dependent" && action == "delete") {
          this.entities.splice(this.entities.indexOf(entity), 1);
        } else {
          const action_obj = new actions_list[action](
            {
              root: this.$root,
              self: this,
              entity_type: this.type
            },
            { entity: entity }
          );
          action_obj.execute();
        }
      } else {
        console.error("No such action", action);
      }
    }
  },
  watch: {
    // If filters changed, reload entities
    appliedFilters: {
      handler() {
        if (this.tableOptions.page != 1) this.tableOptions.page = 1;
        else this.loadEntities();
      },
      deep: true
    },
    // it items per page or page changed, reload entities
    tableOptions: {
      handler() {
        console.log("AdvancedListView.watch.tableOptions", this.tableOptions);
        this.loadEntities();
      },
      deep: true
    },
    // if entity type changed, reload entities
    type() {
      this.loadEntities();
    },
    entities: {
      handler() {
        console.log("AdvancedListView entities changed");
        this.$emit("entitiesChanged", this.entities);
      },
      deep: true
    }
  }
};
</script>

<style scoped></style>
